import { AloftDate, TRIAL_PERIOD_DAYS } from '@aloft/toolkit-shared';
import { Typography } from '@aloft/toolkit-sui';

import { getPlan } from '../../utils/getPlan.ts';
import { CheckoutProps } from './types.ts';

type Props = {
  priceID: CheckoutProps['priceID'];
};

// This text is copied from Stripe Checkout
export function TrialInfo({ priceID }: Props) {
  const { price, interval } = getPlan(priceID);

  // Trials begin 30 days from the current moment:
  // https://docs.stripe.com/billing/subscriptions/trials#:~:text=When%20creating%20a,the%20current%20moment
  const trialStart = AloftDate.today().addDays(TRIAL_PERIOD_DAYS);

  return (
    <Typography variant="body2" color="textTertiary">
      After your trial ends, you will be charged {price.toAbbrString(2)} per {interval}, prior to
      any discounts and taxes, starting on {trialStart.format('MMMM d, yyyy')}. You can cancel at
      any time.
    </Typography>
  );
}
